<template>
    <div class="text-center">
        <photo-viewer
            :photoFn="getPhotosFn(params)"
        >
        </photo-viewer>
    </div>
</template>

<script>
import Vue from 'vue';
import PhotoViewer from '@/components/Image/PhotoViewer';
import PropertyAssessment from '@/services/Property/PropertyAssessment';

export default Vue.extend({
  components: {
    PhotoViewer,
  },
  methods: {
    getPhotosFn(params) {
      const { propertyAssessmentId } = params.data;
      const { propertyId } = this.$route.params;
      return () => PropertyAssessment.getPhotos(propertyId, propertyAssessmentId);
    },
  },
});
</script>

<style lang="scss">
.overflow-cell {
    overflow: visible;
}

.ag-row {
    z-index: 0;

    &.ag-row-focus {
        z-index: 1;
    }
}
</style>
